// extracted by mini-css-extract-plugin
module.exports = {"main-component":"reportGraph_main-component__4jwhk"};